<template>
    <section class="col-12 margin-b-75">

        <header class="col-12 padding-b-25 border-b">
            <label>Tilbehør</label>
            <a class="btn btn--md btn--primary primary--copper margin-t-50" href="#" @click.prevent="$emit('toCreate')">Tilføj tilbehør</a>
        </header>

        <section class="data-list" v-if="items && items.length > 0">

            <transition-group name="fade" tag="section">

                <section class="item" v-for="(item, index) in items" :key="index + ' - ' + item">

                    <section class="icon">

                        <i class="icon--lg fas fa-tag"></i>

                    </section>

                    <section class="content">

                        <h1 v-text="item"></h1>

                    </section>

                    <section class="link">

                        <a href="#" @click.prevent="deleteItem(index)">Slet</a>

                    </section>

                </section>

            </transition-group>

        </section>

        <section class="col-12 center" v-else>

            <p class="margin-t-100">Ingen tilbehør tilføjet</p>

        </section>

    </section>
</template>

<script>
export default {
    name: "index",
    props:['items'],
    methods:{
        deleteItem(index){
            let newItems = [...this.items];
            newItems = newItems.filter((item, itemIndex) => itemIndex !== index)
            this.$emit('updateItems', newItems);
        }
    }
}
</script>

<style scoped>

</style>
